import {TAX_FORECAST_BASE_URL} from 'pages/ais/submit-income-tax-forecast/model/constants';
import {
    TTaxForecastCommonData,
    TTaxForecastCore,
} from 'pages/ais/submit-income-tax-forecast/model/types';
import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

export interface ITaxForecastRequestIdArg {
    requestId: string;
}

export const fetchTaxForecastDataByRequestId = (args: ITaxForecastRequestIdArg) => performRequest<
    TTaxForecastCommonData>({
        url: TAX_FORECAST_BASE_URL,
        params: args,
        method: ERequestType.GET,
    });

export const postTaxForecast = (args: ITaxForecastRequestIdArg) => performRequest<
    string>({
        url: [
            TAX_FORECAST_BASE_URL,
            'send',
        ].join('/'),
        params: args,
        method: ERequestType.POST,
    });

export interface IUpdateTaxForecastArgs {
    id: number;
    entity: TTaxForecastCore;
}
export const updateTaxForecast = ({id, entity}: IUpdateTaxForecastArgs) => performRequest<
    string>({
        url: [
            TAX_FORECAST_BASE_URL,
            'update-comment',
            id,
        ].join('/'),
        data: entity,
        method: ERequestType.PUT,
    });
